<template>
  <div>
    <tTabs
      :selectType.sync="selectType"
      :typeData="typeData"
    />
    <platApply v-if="selectType === '1'" />
    <platQuery v-if="selectType === '2'" />
  </div>
</template>

<script>
import platApply from './components/platApply'
import platQuery from './components/platQuery'
export default {
  name: 'index',
  components: {
    platApply,
    platQuery
  },
  data () {
    return {
      selectType: '1',
      typeData: [
        { id: '1', name: '机构申请' },
        { id: '2', name: '机构查询' }
      ]
    }
  },
  created () {
    const { query } = this.$route
    if (query.id) this.selectType = query.id
  },
  methods: {
    changeType (item) {
      const { id } = item
      this.selectType = id
    }
  }
}
</script>

<style lang="less" scoped>
.group_6 {
  width: 1054px;
  .group_7 {
    margin-right: 15px;
    line-height: 15px;
    .font_4 {
      font-size: 15px;
      font-family: PingFang;
      line-height: 15px;
      font-weight: 700;
    }
    .text_9 {
      color: #cccccc;
      font-size: 14px;
    }
    .text_10 {
      color: #666666;
      font-size: 14px;
      line-height: 14px;
    }
  }
  .group_8 {
    margin-top: 18px;

    .item{
      font-size: 14px;
      color: #999;
      min-width: 122px;
      text-align: center;
      line-height: 40px;
      position: relative;
      top: 3px;
      cursor: pointer;

      &.active{
        color: #0067d1;
        border-bottom: 3px solid #0067d1;
      }
    }
    .font_5 {
      font-size: 15px;
      font-family: Alibaba;
    }
    .text_12 {
      color: #0067d1;
      font-size: 14px;
      line-height: 13px;
    }
    .text_13 {
      color: #999999;
      font-size: 14px;
      line-height: 14px;
    }
  }
  .divider {
    background-color: #0067d14d;
    .section_8 {
      width: 122px;
      height: 3px;
    }
  }
}
</style>
